<template>
  <div>
    <div class="pc">
      <div class="head" :style="{ background: showHead ? '#eee' : 'rgba(238, 238, 238, 0.58)' }">
        <div class="head-left">
          <img class="logo" v-show="$store.state.logo" :src="$store.state.logo" @click="logoFn" alt="">
          <img class="logo-time" :src="pageTime['顶部-时间-en']" v-if="En" alt="">
          <img class="logo-time" :src="pageTime['顶部-时间']" v-else alt="">
        </div>

        <div class="content pc">
          <span class="a" href="" @mouseenter="enter(0)" @mouseleave="leave(0)" :class="{ active: activeIndex === 0 || $route.meta.nav === 'dahui' }" @click="wapTopClick(0)">
            <span><i></i><i></i></span>onference大会
            <big class="big-menu" :style="{ height: activeIndex === 0 ? 0.58 * links[0].length + 'rem'  : 0 }" @click.stop>
              <template v-for="(item, index) in links[0]">
                <small :key="index" @click="routerPoint('/' + item[0].src, '大会', 1, index, item[0]['name'])">
                  {{ $t(item[0]['name' + En]) }}
                </small>
              </template>
            </big>
          </span>
          <span class="a" href="" @mouseenter="enter(1)" @mouseleave="leave(1)" :class="{ active: activeIndex === 1 || $route.meta.nav === 'juzheng' }" @click="wapTopClick(1)">
            <span><i></i><i></i></span>amp创见
            <big class="big-menu" :style="{ height: activeIndex === 1 ? 0.58 * links[1].length + 'rem'  : 0 }" @click.stop>
              <template v-for="(item, index) in links[1]">
                <small :key="index" @click="routerPoint('/' + item[0].src, '创见', 2, index, item[0]['name'])">
                  {{ $t(item[0]['name' + En]) }}
                </small>
              </template>
            </big>
          </span>
          <span class="a" href="" @mouseenter="enter(2)" @mouseleave="leave(2)" :class="{ active: activeIndex === 2 || $route.meta.nav === 'zixun' }" @click="wapTopClick(2)">
            <span><i></i><i></i></span>ommunity资讯
            <big class="big-menu" :style="{ height: activeIndex === 2 ? 0.58 * links[2].length + 'rem'  : 0 }"  @click.stop>
              <template v-for="(item, index) in links[2]">
                <small :key="index" @click="routerPoint('/' + item[0].src, '资讯', 3, index, item[0]['name'])">
                  {{ $t(item[0]['name' + En]) }}
                </small>
              </template>
            </big>
          </span>
          <span class="a" href="" @mouseenter="enter(3)" @mouseleave="leave(3)" :class="{ active: activeIndex === 3 || $route.meta.nav === 'chuangjian' }" @click="wapTopClick(3)">
            <span><i></i><i></i></span>ircle生态
            <big class="big-menu" :style="{ height: activeIndex === 3 ? 0.58 * links[3].length + 'rem'  : 0 }" @click.stop>
              <template v-for="(item, index) in links[3]">
                <small :key="index" @click="routerPoint('/' + item[0].src, '生态', 4, index, item[0]['name'])">
                  {{ $t(item[0]['name' + En]) }}
                </small>
              </template>
            </big>
          </span>
          <el-input
            class="input"
            placeholder=""
            @click.native="$router.push('/search')"
            v-model="search">
            <img slot="prefix" class="search-icon" src="https://static.worldaic.com.cn/2024/web/static/images/home-search.png" alt="">
          </el-input>
          <span class="lang" @click="changeLang">{{ $t("lang") }}</span>
          <span class="lang login" @click="wapClick({})">{{ $t("login") }}</span>
        </div>
        <div class="content wap">
          <span class="lang" @click="changeLang">{{ $t("lang") }}</span>
          <img class="search"  @click="$router.push('/search')" src="https://static.worldaic.com.cn/2024/web/static/images/search1.png" alt="">
          <span class="menu-icon"><span></span><span></span><span></span></span>
        </div>
      </div>

      <!-- <ul class="open" v-if="showOpen && !isPc" @mouseenter="showOpen = true" @mouseleave="showOpen = false">
        <li v-for="(item, index) in links[activeIndex]" :key="index">
          <span class="a" @click="routerPoint('/' + ite.src)" v-for="(ite, ind) in item" :key="ind"><span>{{ $t(ite['name' + En]) }}</span></span>
        </li>
      </ul> -->
    </div>
    <div class="wap" v-if="!isPc">
      <div class="head" :style="{ background: showHead ? '#eee' : 'rgba(238, 238, 238, 0.58)' }">
        <img class="logo" :src="$store.state.logo" @click="logoFn" alt="">
        <div class="content" v-if="!showMenu">
          <span class="lang" @click="changeLang">{{ $t("lang") }}</span>
          <img class="search"  @click="$router.push('/search')" src="https://static.worldaic.com.cn/2024/web/static/images/search1.png" alt="">
          <span class="menu-icon" @click="showMenu = true"><span></span><span></span><span></span></span>
        </div>
        <div class="content" v-else>
          <img class="close" @click="closeMenu" src="https://static.worldaic.com.cn/2024/web/static/images/close-wap.png" alt="">
        </div>
      </div>

      <transition name="fade">>
        <div class="head-content" v-if="showMenu">
          <span class="a" v-for="(item, index) in titles" :key="index"  @click="wapTopClick(index)"><img class="c" src="https://static.worldaic.com.cn/2024/web/static/images/c.png" alt=""> {{ item }} <img class="right" src="https://static.worldaic.com.cn/2024/web/static/images/right-wap.png"></span>
          <template v-if="!isPc">
            <span class="a" v-for="(item, index) in wapTitles" :key="'a' + index" @click="wapClick(item)">{{ $t(item.name) }}<img class="right" src="https://static.worldaic.com.cn/2024/web/static/images/right-wap.png"></span>
          </template>
          <div class="login">
            <span @click="wapClick({})">{{ $t("login") }}</span>
          </div>
        </div>
      </transition>

      <transition name="fade">>
        <div class="open" v-if="activeContent >= 0">
          <div class="fanhui" @click="activeContent = -1">
            <img src="https://static.worldaic.com.cn/2024/web/static/images/left-wap.png" alt="">
            返回一级目录
          </div>
          <div class="name">
            <img src="https://static.worldaic.com.cn/2024/web/static/images/waic.png" alt="">{{ titles[activeContent] }}
          </div>
          <ul>
            <li v-for="(item, index) in links[activeContent]" :key="index" :class="{ active: activeOpen === index }" :style="{ height: activeOpen === index ? heightWap(item) : '1.15rem' }">
              <div class="item-box" v-for="(ite, ind) in item" :key="ind">
                <div class="item-title" @click="routerPointWap('/' + ite.src, item, index)" v-if="ind === 0">
                  <span>{{ $t(ite['name' + En]) }}</span>
                  <img v-if="item.length > 1" src="https://static.worldaic.com.cn/2024/web/static/images/top-wap.png" alt="">
                </div>
                <div class="item-content">
                  <span v-if="ind > 0" @click="routerPointWap('/' + ite.src)" >{{ $t(ite['name' + En]) }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import protal from "@/api/protal";
export default {
  data() {
    return {
      search: '',
      titles: [
        'onference大会', 'amp创见', 'ommunity资讯', 'ircle生态'
      ],
      wapTitles: [
        {
          name: 'join',
          link: '/apply'
        },
        {
          name: 'dahuifuwu',
          link: '/fuwu'
        },
      ],
      links: [],
      showOpen: false,
      activeIndex: -1,
      activeOld: -1,
      showHead: false,
      activeOpen: -1,
      activeContent: -1,
      showMenu: false
    };
  },
  created() {
    this.getNav()
  },
  watch: {
    showOpen(v) {
      if (!v) {
        this.activeIndex = -1
      } else {
        this.activeIndex = this.activeOld
      }
    },
    '$route.path': {
      handler(v) {
        this.$nextTick(() => {
          if (v === '/') {
            this.showHead = false
            window.addEventListener('scroll', e => {
              const scrollY = document.documentElement.scrollTop || document.body.scrollTop
              const height = document.documentElement.clientHeight
              this.showHead = this.$route.path === '/' ? scrollY > height : true
            })
          } else {
            this.showHead = true
          }
        })
      },
      immediate: true
    }
  },
  computed: {
    heightWap() {
      return item => {
        return 1.15 + item.length - 1 + 'rem'
      }
    }
  },
  methods: {
    wapTopClick(index) {
      this.activeContent = index
      let str = ''
      if (index === 0) {
        str = '大会'
      } else if (index === 1) {
        str = '创见'
      } else if (index === 2) {
        str = '资讯'
      } else {
        str = '生态'
      }
      this.$jsAPI('track','firstNavigation',
          {
            'firstNavigation_var': str
          }
      );
      gio('track','firstNavigation',
          {
            'firstNavigation_var': str
          }
      );
    },
    logoFn() {
      this.$jsAPI('track','firstNavigation',
          {
            'firstNavigation_var': '大会logo'
          }
      );
      gio('track','firstNavigation',
          {
            'firstNavigation_var': '大会logo'
          }
      );
      this.$router.push('/')
    },
    getNav() {
      return protal.getJson("home_navigation", (data) => {
        this.links = data.map(x => {
          x = x.filter(y => y[0].showSub)
          return x
        })
        this.$store.commit('setheadMenu', this.links)
        localStorage.setItem('menu', JSON.stringify(this.links))
      });
    },
    changeLang() {
      let locale = this.$i18n.locale;
      locale === "ch" ? (this.$i18n.locale = "en") : (this.$i18n.locale = "ch");
      localStorage.setItem("lang", this.$i18n.locale);
    },
    wapClick(item) {
      this.$jsAPI('track','enterRegistLogin',
          {
            'platform_var': '官网',
            'position_var': `右上角`,
          }
      );
      gio('track','enterRegistLogin',
          {
            'platform_var': '官网',
            'position_var': `右上角`,
          }
      );

      if (!item.link) {
        window.open('https://reg.worldaic.com.cn', '_blank')
        return
      }
      this.closeMenu()
      this.$router.push(item.link)
    },
    closeMenu() {
      this.showMenu = false
      this.activeOpen = -1
      this.activeContent = -1
    },
    routerPoint(path, first, firstNum, secondNum, second) {
      this.$jsAPI('track','secNavigation',
          {
            'firstNavigation_var': first,
            'position_var': `${firstNum}-${secondNum + 1}`,
            'secondNavigation_var': second
          }
      );
      if (path.includes('http')) {
        window.open(path.slice(1), '_blank')
        return
      }
      this.$router.push(path);
      this.scrollTo();
    },
    routerPointWap(path, arr = [], index) {
      let str = ''
      if (this.activeContent === 0) {
        str = '大会'
      } else if (this.activeContent === 1) {
        str = '创见'
      } else if (this.activeContent === 2) {
        str = '资讯'
      } else {
        str = '生态'
      }
      this.$jsAPI('track','secNavigation',
          {
            'firstNavigation_var': str,
            'position_var': `${this.activeContent + 1}-${index + 1}`,
            'secondNavigation_var': arr[0]['name']
          }
      );
      gio('track','secNavigation',
          {
            'firstNavigation_var': str,
            'position_var': `${this.activeContent + 1}-${index + 1}`,
            'secondNavigation_var': arr[0]['name']
          }
      );
      if (arr.length > 1) {
        this.showOpenWap(index)
        return
      }
      this.closeMenu()
      if (path.includes('http')) {
        window.open(path.slice(1), '_blank')
        return
      }
      this.$router.push(path);
      this.scrollTo();
    },
    showOpenWap(index) {
      if (this.activeOpen === index) {
        this.activeOpen = -1
        return
      }
      this.activeOpen = index
    },
    enter(v) {
      this.showOpen = true
      this.activeIndex = v
      this.activeOld = v
    },
    leave(v) {
      this.showOpen = false
    },
  }
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .head {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: .96rem;
    background: #eee;
    z-index: 100;
    padding: 0 1.1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.1);

    .head-left {
      position: absolute;
      left: 1.1rem;
      top: 0;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 1;
    }

    .logo {
      height: .56rem;
      width: auto;
      cursor: pointer;
    }

    .logo-time {
      height: .64rem;
      width: auto;
      margin-left: .06rem;
    }

    .content {
      position: relative;
      flex: 1;
      justify-content: flex-end;
      display: flex;
      align-items: center;

      .a {
        position: relative;
        text-decoration: none;
        font-size: .22rem;
        font-weight: 500;
        color: #595757;
        margin-top: .1rem;
        line-height: .86rem;
        margin-right: .63rem;
        transition: color 1s;
        display: flex;
        cursor: pointer;
        align-items: center;
        font-family: sybold;

        i {
          display: block;
          width: .26rem;
          height: .26rem;
          transition: 1s;

          &:nth-child(1) {
            background: url("https://static.worldaic.com.cn/2024/web/static/images/c.png") no-repeat;
            background-size: auto 100%;
            background-position: right top;
            position: absolute;
            right: 0;
            top: 0;
          }

          &:nth-child(2) {
            width: 0;
            opacity: 0;
            background: url("https://static.worldaic.com.cn/2024/web/static/images/waic.png") no-repeat;
            background-size: auto 100%;
            background-position: right top;
            position: absolute;
            right: 0;
            top: 0;
          }
        }

        span {
          position: relative;
          width: .24rem;
          height: .24rem;
          display: flex;
          align-items: center;
          transition: 1s;
          margin-top: -0.07rem;
        }

        &::before {
          content: "";
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: -1px;
          width: .64rem;
          height: .1rem;
          background: url("https://static.worldaic.com.cn/2024/web/static/images/border-bottom.png") no-repeat;
          background-size: 100% 100%;
          opacity: 0;
          transition: 1s;
        }

        .big-menu {
          position: absolute;
          left: 0;
          min-width: 100%;
          top: .86rem;
          background: rgba(255, 255, 255, 0.8);
          border-radius: 0px 0px .16rem .16rem;
          overflow: hidden;
          transition: 1s;

          small {
            display: block;
            text-align: center;
            color: #595757;
            line-height: .28rem;
            padding: .15rem;
            white-space: nowrap;

            &:hover {
              background: url(https://static.worldaic.com.cn/2024/web/static/images/btn.png);
              background-size: 100% 100%;
              color: #fff;
            }
          }
        }

        &.active {
          color: RGBA(40, 69, 153, 1);

          &::before {
            opacity: 1;
          }

          span {
            width: .96rem;
          }

          i:nth-child(1) {
            width: 0;
            opacity: 0;
          }

          i:nth-child(2) {
            width: .96rem;
            height: .26rem;
            opacity: 1;
          }
        }
      }

      .input {
        width: 1.2rem;
        height: .4rem;
        padding: 0;
        border-radius: 4px;
        margin-right: .2rem;
        position: relative;

        /deep/ .el-input__inner {
          height: .4rem;
          background: #fff;
          border-radius: .04rem;
          border: 1px solid #B2B3B3;
          cursor: pointer;
        }

        /deep/ .el-input__icon {
          line-height: .4rem;
        }

        /deep/ .el-input__prefix {
          left: 0 !important;
        }

        .search-icon {
          position: absolute;
          left: 0.08rem;
          top: 50%;
          transform: translateY(-50%);
          width: .24rem;
          height: .24rem;
        }
      }

      .lang {
        display: flex;
        align-items: center;
        justify-content: center;
        width: .4rem;
        height: .4rem;
        border-radius: 4px;
        font-size: .22rem;
        border: 1px solid #B2B3B3;
        cursor: pointer;
        color: #888;

        &:hover {
          color: #0361FF;
          border: 1px solid #0361FF;
        }
      }

      .login {
        padding: 0 .05rem;
        margin-left: .16rem;
        width: auto;
      }
    }
  }

  .open {
    position: fixed;
    right: 2.9rem;
    top: .96rem;
    width: 9.76rem;
    padding: 0 0 .01rem;
    background: rgba(238, 238, 238, 0.8);
    border-radius: 0px 0px .16rem .16rem;
    display: flex;
    justify-content: space-between;
    z-index: 99;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: .6rem;
      background: #eee;
    }

    li {
      position: relative;
      flex: 1;
      justify-content: center;
      z-index: 1;

      .a {
        text-align: center;
        display: block;
        font-size: .2rem;
        color: #595757;
        cursor: pointer;
        margin-top: .09rem;
        font-family: sybold;

        span {
          display: inline-block;
          padding: .1rem .2rem;
          border-radius: .3rem;
          transition: .5s;
          font-family: sybold;
        }

        &:last-child {
          margin-bottom: .3rem;
        }

        &:nth-of-type(1) {
          line-height: .6rem;
          margin-top: 0;
          margin-bottom: 0;
          
          span {
            display: inline;
          }
        }

        &:hover {
          span {
            color: #fff;
            background: rgba(3, 97, 255, 1);
          }

          &:nth-of-type(1) {
            span {
              color: #0361FF;
              background: none;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1080px) and (min-width: 768px) {
  .head .content .a {
    margin-right: .45rem;
  }
}
@media screen and (max-width: 768px) {
  .head {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 1rem;
    background: rgba(238, 238, 238, 0.58);
    box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.1);
    z-index: 100;
    padding: 0 .32rem;
    display: flex !important;
    justify-content: space-between;
    align-items: center;
    
    .content {
      position: relative;
      flex: 1;
      justify-content: flex-end;
      display: flex;
      align-items: center;

      .search {
        width: .32rem;
        margin: 0 .28rem;
      }

      .lang {
        display: flex;
        align-items: center;
        justify-content: center;
        width: .4rem;
        height: .4rem;
        border-radius: 4px;
        font-size: .22rem;
        border: 1px solid #B2B3B3;
        cursor: pointer;
        color: #888;

        &:hover {
          color: #0361FF;
          border: 1px solid #0361FF;
        }
      }

      .menu-icon {
        width: .36rem;
        height: .29rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        span {
          width: .36rem;
          height: 2px;
          background: #595757;
          border-radius: 2px;
        }
      }

      .close {
        width: .36rem;
        height: .36rem;
      }
    }

    .logo {
      height: .5rem;
      width: auto;
    }
  }

  .head-content {
    position: fixed;
    left: 0;
    top: 1rem;
    width: 100%;
    bottom: 0;
    z-index: 98;
    background: #f5f5f5;
    padding: 0 .32rem;
    padding-top: .08rem;

    .a {
      height: 1.17rem;
      border-bottom: 1px solid #ccc;
      display: flex;
      align-items: center;
      text-align: left;
      position: relative;
      font-size: .32rem;
      color: #595757;
      line-height: .36rem;
      font-family: sybold;

      .c {
        width: auto;
        height: .36rem;
      }

      .right {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: .36rem;
        height: .36rem;
      }
    }
    
    .login {
      margin: 2rem auto .5rem;
      display: flex;
      justify-content: center;
      
      span {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 4.8rem;
        height: .88rem;
        border-radius: .06rem;
        border: 1px solid #B2B3B3;
        font-size: .32rem;
        color: #595757;
      }
    }
  }

  .open {
    position: fixed;
    left: 0;
    top: 1rem;
    width: 100%;
    bottom: 0;
    z-index: 99;
    background: #f5f5f5;
    padding: 0 .32rem 1rem;
    overflow: auto;

    .fanhui {
      height: 1.08rem;
      display: flex;
      align-items: center;
      font-size: .28rem;
      color: #595757;
      line-height: .28rem;

      img {
        width: .24rem;
        height: .24rem;
        margin-right: .08rem;
      }
    }

    .name {
      height: 1rem;
      display: flex;
      align-items: center;
      font-size: .32rem;
      color: RGBA(40, 69, 153, 1);
      font-family: sybold;
      border-bottom: 1px solid #ccc;

      img {
        width: auto;
        height: .36rem;
      }
    }

    ul {
      li {
        overflow: hidden;
        transition: .5s;
        
        .item-title {
          height: 1.15rem;
          border-bottom: 1px solid #ccc;
          display: flex;
          justify-content: space-between;
          align-items: center;
          text-align: left;
          position: relative;
          font-size: .32rem;
          color: #595757;
          line-height: .36rem;
          font-family: sybold;

          img {
            width: .36rem;
            height: .36rem;
            transform: rotate(180deg);
            transition: .5s;
          }
        }

        &.active {
          .item-title {
            img {
              transform: rotate(0deg);
            }
          }
        }

        .item-content {
          width: 6.22rem;
          margin: 0 auto;
          overflow: hidden;

          span {
            display: block;
            height: 1rem;
            border-bottom: 1px solid #ccc;
            display: flex;
            align-items: center;
            text-align: left;
            position: relative;
            font-size: .32rem;
            color: #595757;
            line-height: .36rem;
          }
        }

      }
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: transform .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transform: translateX(100vw);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/head.vue